/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

export default '52.6.11';
